import { Component, Input, OnInit } from '@angular/core';
import { ReportDetail } from '../report.manager.model';
import { Constants } from '../../../constants.new';
import * as _ from 'lodash';
import { ReportType } from '../report-type';

@Component({
    selector: 'further-limit-panel-value',
    template: `
        <div style="display: flex; white-space: nowrap; gap: 50px;">
            <div style="display: flex; align-items: baseline; gap: 5px;">
                <label>Tax Year: </label>
                <select [(ngModel)]="report.criteria.taxYear" class="form-select-sm" style="width: 80px;">
                    <option [ngValue]=""></option>
                    @for (year of availableYears; track year) {
                        <option [ngValue]="year">{{ year }}</option>
                    }
                </select>
            </div>
            @if (report.reportTypeId === reportTypes.ARBValue || report.reportTypeId === reportTypes.ARBCoverLetter) {
                <div style="display: flex; align-items: baseline; gap: 5px;">
                    <label>Filing Deadline Range:</label>
                    <weissman-datetime
                        [(inputDate)]="report.criteria.filingDeadlineStart"
                        [dateOnly]="true"
                        [timeZone]="'Central'"
                    >
                    </weissman-datetime>
                    to
                    <weissman-datetime
                        [(inputDate)]="report.criteria.filingDeadlineEnd"
                        [dateOnly]="true"
                        [timeZone]="'Central'"
                        [rangeEnd]="true"
                    >
                    </weissman-datetime>
                </div>
            }
            <div style="display: flex; gap: 5px; align-items: baseline;">
                <label>Property Type: </label>
                <select multiple [(ngModel)]="report.criteria.propertyTypeIDs" class="form-select-sm">
                    @for (propType of propertyTypes; track propType) {
                        <option [ngValue]="propType.propertyTypeId">{{ propType.name }}</option>
                    }
                </select>
            </div>
            @if (report.reportTypeId === reportTypes.ARBValue || report.reportTypeId === reportTypes.ARBCoverLetter) {
                <div style="display: flex; gap: 5px; align-items: baseline;">
                    <label>NOD Batch Number: </label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        style="width: 120px;"
                        [(ngModel)]="report.criteria.nodBatchNumber"
                    />
                </div>
            } @else if (report.reportTypeId !== reportTypes.ARBCoverLetter) {
                <div>
                    <label>
                        <ws-switch [(ngModel)]="report.criteria.showExemptions"></ws-switch> Show Exemptions
                    </label>
                </div>
            }
            @if (report.reportTypeId === reportTypes.InitialValue) {
                <div>
                    <label>
                        <ws-switch [(ngModel)]="report.criteria.showAllParcels"></ws-switch> Show All Parcels
                    </label>
                </div>
            }
        </div>
    `,
    standalone: false,
})
export class FurtherLimitPanelValueComponent implements OnInit {
    constructor(private constants: Constants) {}

    @Input() report: ReportDetail;
    @Input() availableYears: number[];
    @Input() hasRyanPrivatePermission: boolean;

    propertyTypes: any[];
    reportTypes = ReportType;

    ngOnInit() {
        if (!this.report.criteria.taxYear) {
            const newYearValue = new Date().getFullYear() - 3;
            this.report.criteria.taxYear = newYearValue;
        }

        this.propertyTypes = _.map(this.constants.PropertyTypeNames, (name: string, id: number) => {
            return {
                name: name,
                propertyTypeId: Number(id),
            };
        });

        this.report.criteria.propertyTypeIDs = this.report.criteria.propertyTypeIDs || [1, 2, 3, 4];
        this.report.criteria.showExemptions = this.report.criteria.showExemptions || false;
        this.report.criteria.showAllParcels = this.report.criteria.showAllParcels || false;
    }
}
